module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/custom-collective-2-61e824539bf2a88b37a401dbfac657c2.jpg";